module.exports = function () {
    $(document).ready(function () {

        var modal = $('#edit-room-modal');
        var openModalButton = $('.open-edit-room-button');
        var submitModalFormButton = $('.modal-submit-button');

        var editRoomController  = new (require('./modules/rooms/EditRoomController'))(modal);
        var modalFormController = new (require('./services/modals/ModalFormController'))(modal);

        var globalRoomId = null;

        console.log('EDIT ROOM!');

        openModalButton.on('click', function(){
            var $modal = $('#edit-room-modal');
            modalFormController.cleanErrors();

            var $roomId = $(this).data('room');
            globalRoomId = $roomId;

            editRoomController.getRoom($roomId, function(roomObject) {
                $modal.find('#field_name').val(roomObject.name);
                $modal.find('#field_key_number').val(roomObject.key_number);
                $modal.find('#field_price').val(roomObject.price);

                if (roomObject.head_guardian == 1) {
                    $modal.find('#head_guardian').prop('checked', true);
                } else {
                    $modal.find('#head_guardian').attr('checked', false);
                }

                if (roomObject.is_couple == 1) {
                    $modal.find('#is_couple').prop('checked', true);
                } else {
                    $modal.find('#is_couple').attr('checked', false);
                }

	            if (roomObject.exclude_display == 1) {
		            $modal.find('#exclude_display').prop('checked', true);
	            } else {
		            $modal.find('#exclude_display').attr('checked', false);
	            }
            });

            $modal.modal("show");
        });

        function getFormData($form){
            var unindexed_array = $form.serializeArray();
            var indexed_array = {};

            $.map(unindexed_array, function(n, i){
                indexed_array[n['name']] = n['value'];
            });

            return indexed_array;
        }

        submitModalFormButton.on('click',function (e) {
            e.preventDefault();
            if (globalRoomId != '') {

                var fields = getFormData(modal.find('form'));
                fields['id'] = globalRoomId;

                // send update ajax
                editRoomController.updateRoom(fields, function(room){

                    if (room != null) {
                        var tableTd = $('#manage-rooms');
                        tableTd.find('tbody tr[data-id="' + parseInt(room[0].id) + '"] td:nth-child(2)').html( room[0].name );
                        tableTd.find('tbody tr[data-id="' + parseInt(room[0].id) + '"] td:nth-child(5)').html( room[0].key_number );
                        tableTd.find('tbody tr[data-id="' + parseInt(room[0].id) + '"] td:nth-child(6)').html( room[0].price );

                        modalFormController.cleanErrors();
                        modalFormController.clearModal();
                        modalFormController.closeModal();
                    }

                }, function (errors) {

                    modalFormController.displayErrors(errors);

                });
            }
        });

    });
}();